module.exports = __webpack_public_path__ + "static/media/kinedu_educadores_white.738c663d.png";